import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

import type { CohortValues } from '../utils';
import { COHORTS } from '../utils';

type ExperimentEnrollment = {
	cohort: CohortValues;
	isTreatment: boolean;
	isEnrolled: boolean;
};

export const useExperimentEnrollment = (
	experimentName: string,
	skip?: boolean,
): ExperimentEnrollment => {
	if (skip) {
		return {
			cohort: COHORTS.NOT_ENROLLED,
			isTreatment: false,
			isEnrolled: false,
		};
	}
	// eslint-disable-next-line confluence-feature-gating/static-feature-gates
	const [experiment] = UNSAFE_noExposureExp(experimentName);
	const cohort = experiment.get<CohortValues>('cohort', COHORTS.NOT_ENROLLED) as CohortValues;

	return {
		cohort,
		isTreatment: cohort === COHORTS.TREATMENT,
		isEnrolled: cohort === COHORTS.TREATMENT || cohort === COHORTS.CONTROL,
	};
};
